import * as Dialog from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import { useI18n } from '@/contexts/i18n-hook';

interface ModalHeaderProps {
  numeroFormatado: string;
  nomeParte: string;
  setNomeParte: (nome: string) => void;
}

/**
 * Verifica se os parênteses no texto estão balanceados
 * @param texto Texto a ser validado
 * @returns true se parênteses estão balanceados, false caso contrário
 */
function verificarParentesesBalanceados(texto: string): boolean {
  let contador = 0;
  for (const char of texto) {
    if (char === '(') contador++;
    if (char === ')') contador--;
    // Se contador ficar negativo, significa que fechou sem abrir
    if (contador < 0) return false;
  }
  // Se contador for 0, todos foram fechados; se > 0, há abertura sem fechamento
  return contador === 0;
}

export function ModalHeader({ numeroFormatado, nomeParte, setNomeParte }: ModalHeaderProps) {
  const { t } = useI18n();
  // Verificar se há parênteses desbalanceados
  const temParenteses = nomeParte.includes('(');
  const parentesesDesbalanceados = temParenteses && !verificarParentesesBalanceados(nomeParte);

  return (
    <div className="flex items-center justify-between mb-6">
      <div className="flex-1">
        <Dialog.Title className="text-2xl font-bold text-gray-900 mb-2">
          {numeroFormatado} - {nomeParte}
        </Dialog.Title>
        <div className="mt-2">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            {t('apreciacaoModais.editarParte.nomeRotulo')}
          </label>
          <input
            type="text"
            value={nomeParte}
            onChange={(e) => setNomeParte(e.target.value)}
            className={`w-full rounded-md px-3 py-2 text-sm ${parentesesDesbalanceados
                ? 'border-2 border-red-500 focus:border-red-500 focus:ring-red-500'
                : 'border border-gray-300 focus:border-blue-500 focus:ring-blue-500'
              }`}
            placeholder={t('apreciacaoModais.editarParte.nomePlaceholder')}
          />
          {parentesesDesbalanceados && (
            <p className="text-xs text-red-600 mt-1">
              {t('apreciacaoModais.editarParte.parentesesAviso')}
            </p>
          )}
        </div>
      </div>
      <Dialog.Close asChild>
        <button className="text-gray-400 hover:text-gray-600 ml-4">
          <X className="h-6 w-6" />
        </button>
      </Dialog.Close>
    </div>
  );
}

